<template>
  <div>
    <div class="mb-3 font-size-subtitle-2 font-weight-regular">
      <span class="text-red">＊</span>
      <span>已選取全部配料庫，請選擇要套用至哪些門市，按下確認後即複製</span>
    </div>
    <nd-multi-select-listbox
      :brandId="brandId"
      :getDataH="getDataH"
      :storeId="storeId"
      :type="1"
      @update:choose="updateChoose"
    />
    <div class="clear-both" />
    <div class="mt-1 font-size-subtitle-2 text-right">已選{{ chose.length }}擇</div>
  </div>
</template>

<script>
import NdMultiSelectListbox from '@/components/elements/nd-multi-select-listbox.vue'

export default {
  name: 'nd-copy-options-store',
  props: {
    brandId: {
      type: Number,
      default: 0
    },
    getDataH: {
      type: Function
    },
    storeId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      chose: []
    }
  },
  components: {
    'nd-multi-select-listbox': NdMultiSelectListbox
  },
  methods: {
    updateChoose (val) {
      this.chose = val
      this.$emit('update:choose', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-1 {
  margin-top: 4px;
}
.clear-both {
  clear: both;
}
.font-size-subtitle-2 {
  font-size: 14px;
}
.font-weight-regular {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// nd-copy-options-store.vue?9bf204ce